import { commonStyles } from '../commonStyles';
import { KubitProgressBarVariantType } from '../variants';
export const getLinearRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [KubitProgressBarVariantType.LINEAR_REGULAR]: {
            ...commonStyles(FOUNDATIONS, FONT),
            bar: {
                ...commonStyles(FOUNDATIONS, FONT).bar,
                background: FOUNDATIONS.color_comp_status_progressbar_linear_regular_empty_bg,
            },
            progressBar: {
                ...commonStyles(FOUNDATIONS, FONT).progressBar,
                background: FOUNDATIONS.color_comp_status_progressbar_linear_regular_filled_bg,
            },
        },
    };
};
//# sourceMappingURL=linearRegular.js.map